import { getKeys } from './getKeys'

export const homeSwitchTranslations = {
  SWITCH_HOME_TITLE: 'This data is at a different home',
  SWITCH_HOME_DESCRIPTION:
    "You're currently viewing {{currentHomeName}}. To see this data, you'll be switched to {{requestedHomeName}}."
}

export const homeSwitchConstants = getKeys(homeSwitchTranslations)
